import React, { useState, useEffect } from "react";

export default function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollPercent, setScrollPercent] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const scrollProgress = (scrollTop / docHeight) * 100;

      setScrollPercent(scrollProgress);
      setIsVisible(scrollTop > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    isVisible && (
      <div
        onClick={scrollToTop}
        style={{
          position: "fixed",
          bottom: "40px",
          right: "40px",
          width: "60px",
          height: "60px",
          cursor: "pointer",
        }}
      >
        {/* Gradient definition */}
        <svg width="0" height="0">
          <defs>
            <linearGradient id="scrollGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="rgba(230, 92, 91, 0.9)" />
              <stop offset="100%" stopColor="rgba(245, 93, 44, 0.9)" />
            </linearGradient>
          </defs>
        </svg>

        {/* Circular progress ring */}
        <svg
          width="60"
          height="60"
          viewBox="0 0 36 36"
          style={{
            transform: "rotate(-90deg)",
            position: "absolute",
            top: 0,
            left: 0,
          }}
        >
          <path
            d="M18 2.0845
               a 15.9155 15.9155 0 0 1 0 31.831
               a 15.9155 15.9155 0 0 1 0 -31.831"
            fill="none"
            stroke="#ddd"
            strokeWidth="2"
          />
          <path
            d="M18 2.0845
               a 15.9155 15.9155 0 0 1 0 31.831
               a 15.9155 15.9155 0 0 1 0 -31.831"
            fill="none"
            stroke="url(#scrollGradient)"
            strokeWidth="2"
            strokeDasharray={`${scrollPercent}, 100`}
          />
        </svg>

        {/* Arrow Button */}
        <div
          style={{
            width: "44px", // increased size
            height: "44px", // increased size
            borderRadius: "50%",
            background: "linear-gradient(to right, rgba(230, 92, 91, 0.9), rgba(245, 93, 44, 0.9))",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "25px", 
            cursor: "pointer",
            position: "absolute",
            top: "8px",
            left: "8px",
            boxShadow: "0 4px 6px rgba(0,0,0,0.3)",
          }}
        >
          ↑
        </div>
      </div>
    )
  );
}
